
import { getCheckinDictionarySync } from '../lib/checkinTranslations';

// --- i18n Translation System ---
const translations: Record<string, Record<string, string>> = {
  en: {
    app_name: "EduGravity",
    // Auth
    who_are_you: "Who are you?",
    principal_admin: "Principal / Admin",
    principal_admin_desc: "I manage the school and staff.",
    teacher: "Teacher",
    teacher_desc: "I lead a class.",
    parent: "Parent",
    parent_desc: "I have a child enrolled here.",
    profile_details: "Profile Details",
    your_full_name: "Your Full Name",
    your_photo: "Your Photo",
    gender: "Gender",
    phone_number: "Phone Number",
    preferred_language: "Preferred Language",
    teacher_invitation_code: "Teacher Invitation Code",
    setup_organization: "Setup Organization",
    organization_logo: "Organization Logo",
    organization_name: "Organization Name",
    organization_phone: "Organization Phone",
    country: "Country",
    state: "State",
    city: "City",
    street_address: "Street Address",
    school: "School",
    coaching_center: "Coaching Center",
    next: "Next",
    next_setup_org: "Next: Setup Organization",
    finish_setup: "Finish Setup",
    request_to_join: "Request to Join",
    launch_platform: "Launch Platform",
    code_not_found: "Code not found",
    
    // Common
    cancel: "Cancel",
    save: "Save",
    save_changes: "Save Changes",
    delete: "Delete",
    edit: "Edit",
    send: "Send",
    close: "Close",
    loading: "Loading...",
    processing: "Processing...",
    logout: "Logout",
    edit_profile: "Edit Profile",
    help: "Help",
    privacy_policy: "Privacy Policy",
    date: "Date",
    submit: "Submit",
    badges: "Badges",
    reactions: "Reactions",
    kudos_corner: "Kudos Corner",
    management: "Management",
    
    // Principal
    principal: "Principal",
    vice_principals: "Vice Principals",
    manage_staff: "Manage Staff",
    staff_chat: "Staff Chat",
    broadcast: "Broadcast",
    smart_calendar: "Smart Calendar",
    kudos_log: "Kudos Log",
    send_kudo: "Send Kudo",
    create_academic_year: "Create Academic Year",
    manage_academic_year: "Manage Academic Year",
    class_management: "Class Management",
    my_classes: "My Classes",
    no_classes_assigned: "No classes assigned.",
    no_classes_assigned_desc: "Contact admin.",
    students_count: "{{count}} Students",
    pending_count: "{{count}} Pending",
    pending_requests: "Pending Requests",
    students: "Students",
    active_students: "Active Students",
    attendance: "Attendance",
    todays_attendance: "Today's Attendance",
    weekly_checkin_rate: "Check-in Rate",
    status_active: "Active",
    status_upcoming: "Upcoming",
    status_archived: "Archived",
    teachers: "Teachers:",
    none_assigned: "None",
    add_new_class: "Add New Class",
    assign_teachers: "Assign Teachers",
    assign_teachers_to: "Assign Teachers to",
    manage_students: "Manage Students",
    manage_students_desc: "Move, graduate, or remove students.",
    select_all_students: "Select All Students",
    action_move: "Move to...",
    action_graduate: "Graduate",
    action_remove: "Remove",
    select_destination_class: "Select Class",
    invite_parents: "Invite Parents",
    
    // Teacher
    assign_homework: "Assign Homework",
    homework: "Homework",
    chat: "Chat",
    assessments: "Assessments",
    insights: "Insights",
    student_conversations: "Student Conversations",
    take_attendance: "Take Attendance",
    edit_attendance: "Edit Attendance",
    submit_attendance: "Submit Attendance",
    
    // Parent
    my_children: "My Children",
    no_children_added: "No children added.",
    add_child_prompt: "Add your child to get started.",
    add_child: "Add Child",
    child_full_name: "Child Name",
    invitation_code: "Invitation Code",
    send_join_request: "Send Request",
    edit_child: "Edit Child",
    request_pending: "Request Pending",
    pending_prompt: "Your request to join {{childName}} in {{className}} is pending approval.",
    request_declined: "Request Declined",
    declined_prompt: "Request for {{childName}} in {{className}} was declined.",
    confirm_delete_child: "Delete {{childName}}?",
    reports_checkin: "Reports & Check-in",
    exam_results: "Exam Results",
    character_compass: "Character Compass",
    compass_intro: "Track character growth.",
    recent_conversations: "Recent Conversations",
    no_prompts_yet: "No prompts yet.",
    unlock_insights: "Unlock Insights",
    unlock_insights_prompt: "Complete weekly check-in to unlock.",
    submit_weekly_checkin: "Submit Check-in",
    weekly_checkin: "Weekly Check-in",
    one_submission_per_week: "1/Week",
    submission_window_closed: "Window Closed",
    submission_window_closed_msg: "Open Thu-Sun.",
    submission_window_info: "Next: Thursday",
    
    // Modals & Forms
    homework_for_date: "For Date",
    attach_whiteboard_photo: "Attach Photo",
    type_or_speak_homework: "Type or speak...",
    process_with_ai: "Process with AI",
    post_homework: "Post",
    event_title: "Event Title",
    start_date: "Start Date",
    end_date: "End Date",
    event_type: "Event Type",
    description: "Description",
    send_to: "Send to",
    all_classes: "All Classes",
    no_homework_posted: "No homework posted for this date.",
    completed: "Completed",
    
    // Calendar types
    school_event: "School Event",
    holiday: "Holiday",
    meeting: "Meeting",
    exam: "Exam",
    deadline: "Deadline",
    class_event: "Class Event",
    urgent_off: "Urgent Off",
    
    // Checkin Questions (Reflects new content)
    q_study_stress: "1. Academic Balance",
    g_study_stress: "Was your child able to manage their workload without high stress?",
    
    q_understanding: "2. Conceptual Understanding",
    g_understanding: "Did your child feel confident with what they learned in class?",
    
    q_physical_activity: "3. Physical Health",
    g_physical_activity: "Did your child get regular physical activity (60–120 mins/day)?",
    
    q_screen_time: "4. Digital Wellness",
    g_screen_time: "Was non-school screen time kept within healthy limits?",
    
    q_daily_routine: "5. Routine & Rest",
    g_daily_routine: "Did your child follow a healthy rhythm (sleep, meals, and rest)?",
    
    q_social_emotional: "6. Social & Emotional Growth",
    g_social_emotional: "Did your child demonstrate positive behaviors?",
    
    q_needs_support: "7. School Support",
    g_needs_support: "Do you feel your child needs specific support right now?",

    // Checkin Options
    opt_always: "Always",
    opt_mostly: "Mostly",
    opt_rarely: "Rarely",
    opt_not_at_all: "Not at all",
    
    opt_fully_understood: "Fully Understood",
    opt_mostly_understood: "Mostly Understood",
    opt_struggled: "Struggled with some",
    opt_needed_help: "Needed significant help",
    
    opt_daily: "Daily",
    opt_4_5_days: "4–5 Days",
    opt_1_3_days: "1–3 Days",
    opt_no_little: "No/Very little",
    
    opt_yes_consistently: "Yes, consistently",
    opt_most_days: "Most days",
    opt_occasionally: "Occasionally exceeded",
    opt_way_over: "Way over limit",
    
    opt_very_consistent: "Very consistent",
    opt_somewhat_consistent: "Somewhat consistent",
    opt_inconsistent: "Inconsistent/Disrupted",
    
    opt_often: "Often",
    opt_sometimes: "Sometimes",
    opt_not_observed: "Not observed",
    
    opt_no_doing_well: "No, they are doing well",
    opt_yes_discuss: "Yes, let’s discuss",

    weekly_checkin_honesty_note: "Help us support your child’s growth. Please HONESTLY reflect on their routines.",
    please_answer_all: "Please answer all questions.",
    additional_details: "Additional Information (Optional)",
    
    // Kudos
    no_kudos_yet: "No kudos yet.",
    total_kudos_given: "Total Kudos",
    this_past_week: "This Week",
    most_awarded_badge: "Top Badge",
    principals_award: "Principal's Award",
    share_kudo: "Share Kudo",
    download_certificate: "Download",
    include_note: "Include Note",
    preparing: "Preparing...",
    share: "Share",
    certificate_of_achievement: "Certificate of Achievement",
    awarded_to: "Awarded to",
    awarded_by: "Awarded by",
    select_students: "Select Students",
    search_student_by_name: "Search...",
    deselect_all: "Deselect All",
    select_all: "Select All",
    add_personal_note: "Add note...",
    
    // Assessments / Results
    create_assessment: "Create Exam",
    edit_assessment: "Edit Exam",
    exam_title: "Title",
    exam_date: "Date",
    subjects_and_marks: "Subjects & Marks",
    type_marks: "Marks",
    type_grade: "Grade",
    type_comment: "Comment",
    add_subject: "Add Subject",
    save_draft: "Save Draft",
    submit_for_approval: "Submit",
    approve_and_publish: "Approve & Publish",
    request_changes: "Request Changes",
    principal_note: "Principal's Note",
    correction_reason: "Reason",
    withhold_result: "Withhold",
    withheld: "Withheld",
    result_withheld_msg: "Result Withheld",
    total_score: "Total",
    subject: "Subject",
    score: "Score",
    grade: "Grade",
    official_record_note: "Digital record only.",
    exam_status_draft: "Draft",
    exam_status_submitted: "Pending",
    exam_status_needs_revision: "Revision",
    exam_status_published: "Published",
    pending_approval: "Pending Approval",
    no_pending_approvals: "No pending approvals.",
    confirm_publish: "Publish {{count}} results?",
    max_marks: "Max Marks",
    type_marks_label: "Numeric Marks",
    type_grade_label: "Grade (A-F)",
    type_comment_label: "Comment Only",
    correction_history: "Correction History",
    generate_report_cards: "Generate Reports",
    batch_print: "Batch Print",
    download_pdf: "Download PDF",
    print: "Print",
    remarks: "Remarks",
    view_details: "View",
    hide_details: "Hide",
    digital_scoreboard: "Scoreboard",
    print_official: "Print Official",
    release_result: "Release",
    percentage: "Percentage",
    
    // Family Connect
    family_connect: "Family Connect",
    family_connect_prompt: "Conversation starters.",
    parent_tip: "Tip:",
    generate_new_idea: "New Idea",
    generating: "Generating...",
    shuffle_idea: "Shuffle",
    
    // Misc
    communication: "Communication",
    students_stats: "Stats",
    approvals: "Approvals",
    at_a_glance: "At a Glance",
    
    // Invite Slips
    generate_parent_invites: "Generate parent invites.",
    how_many_codes: "How many?",
    print_invitation_slips: "Print Slips",
    invitation_slips_for: "Invites for {{className}}",
    instructions_for_parent: "Instructions:",
    parent_instruction_1: "1. Get EduGravity app.",
    parent_instruction_2: "2. Signup as Parent.",
    parent_instruction_3: "3. Add Child with code:",
    your_unique_code: "CODE",
    generate_codes: "Generate Codes",
    
    // Edit Org
    edit_organization: "Edit Organization",
    
    // Absence
    report_absence: "Report Absence",
    reason_for_absence: "Reason for Absence",
    sick: "Sick",
    yes: "Yes",
    no: "No",
    partially: "Partially",
    sometimes: "Sometimes",
    family_event: "Family Event",
    appointment: "Appointment",
    other: "Other",
    
    // Messaging
    processing_translation: "Translating...",
    see_original: "See Original",
    show_original: "Show Original",
    see_translation: "See Translation",
    translate: "Translate",
    listen: "Listen",
    stop: "Stop",
    stop_listening: "Stop",
    audio_playing: "Playing...",
    announcement_by: "By {{senderName}}",
    type_your_message: "Type your message here...",
    broadcast_announcement: "Broadcast Announcement",
    
    // Insights
    analyzing_data: "Analyzing...",
    generate_weekly_insights: "Generate Insights",
    overall_summary: "Summary",
    students_to_watch: "Watch List",
    suggested_actions: "Actions",
    no_approved_students: "No approved students.",
    draft_message_to_parent: "Draft Message",
    
    // Calendar
    present: "Present",
    late: "Late",
    absent: "Absent",
    manage_calendar: "Manage Calendar",
    add_event: "Add Event",
    edit_event: "Edit Event",
    confirm_delete_event: "Delete this event?",
    
    // Staff/Org Management
    confirm_remove_teacher: "Remove {{teacherName}}?",
    teacher_full_name: "Teacher Full Name",
    teacher_email: "Teacher Email",
    send_invitation: "Send Invitation",
    generate_teacher_invite_codes: "Generate Teacher Invite Codes",
    teacher_invite_codes: "Teacher Invite Codes",
    tab_pending: "Pending",
    tab_active: "Active",
    tab_invite: "Invite",
    invite_teacher_directly: "Invite Teacher Directly",
    
    // Academic Year
    create_academic_year_title: "Create Academic Year",
    year_name_placeholder: "e.g. 2026-27, Fall 2026, or Foundation Batch 2026-28",
    save_year: "Save Year",
    copy_class_structure: "Copy Class Structure",
    select_year_to_copy: "Select Year to Copy",
    review_rename_classes: "Review & Rename Classes",
    create_new_class: "Create New Class",
    edit_class: "Edit Class",
    confirm_delete_academic_year: "Delete {{yearName}}?",
    
    // Errors
    access_denied: "Access Denied",
    approval_pending: "Approval Pending",
    approval_pending_desc: "Waiting for {{orgName}} to approve.",
    access_denied_rejected_desc: "Your request was rejected.",
    access_denied_removed_desc: "You have been removed.",
  }
};

export const useTranslate = (langCode: string = 'en') => {
  const t = (key: string, replacements?: Record<string, string>): string => {
    const checkinDict = getCheckinDictionarySync(langCode);
    const langSet = translations[langCode] || translations['en'];
    let text = (checkinDict as any)?.[key] || langSet?.[key] || translations['en']?.[key] || key;

    if (replacements) {
      for (const [placeholder, value] of Object.entries(replacements)) {
        text = text.replace(new RegExp(`{{${placeholder}}}`, 'g'), value);
      }
    }
    return text;
  };
  return t;
};
